export default __webpack_public_path__ + "static/media/sample.ac0398d4.pdf";